<template>
  <v-col
    cols="12"
    md="4"
    class="primary--text font-weight-bold text-center"
  >
    {{ labelText }}
    <avs-button
      color="blue white--text"
      :disabled="disabled || isLoading"
      iconI="mdi-upload"
      class="mb-5"
      @click="onAddClicked"
      :spantext="$t('actions.upload', { entity: $tc('commons.picture', 1).toLowerCase() })"
      ><template v-slot:name>{{
        $t("actions.upload", { entity: $tc("commons.picture", 1).toLowerCase() })
      }}</template>
    </avs-button>
    <v-row class="justify-center">
      <v-col
        cols="12"
        sm="9"
        md="9"
        v-if="value"
      >
        <v-card class="mx-auto overflow-hidden">
          <div :style="{ position: 'relative' }">
            <v-fade-transition>
              <v-overlay
                v-show="value.hover"
                absolute
                color="primary"
                z-index="99"
              >
              </v-overlay>
            </v-fade-transition>
            <v-img
              :src="value"
              height="150"
              width="250"
            ></v-img>
          </div>
          <avs-deleteButton
            @click.stop="handleOpenDeleteDialog"
            :spantext="
              $t('actions.delete', {
                entity: $tc('commons.picture', 1).toLowerCase()
              })
            "
          />
        </v-card>
      </v-col>
    </v-row>
    <input
      v-show="false"
      type="file"
      accept="image/*"
      @change="hasChanged"
      ref="uploadInput"
    />
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      @cancel="handleCancel"
      @delete="onDeleteClicked"
      resource="signature picture"
    />
  </v-col>
</template>

<script>
import { imageValidator } from "@/utils/validator"

export default {
  name: "ImageInput",
  props: {
    value: {
      type: [String, null],
      required: false
    },
    labelText: {
      // Nouvelle prop pour le texte du label
      type: String,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasValue() {
      return this.value
    }
  },
  data() {
    return {
      isLoading: false,
      deleteDialogIsOpen: false
    }
  },
  methods: {
    hasChanged(e) {
      e.target.files.forEach((file, i) => {
        if (file && imageValidator(file)) {
          this.isLoading = true
          let reader = new FileReader()
          reader.addEventListener("load", () => this.update(reader), false)
          reader.readAsDataURL(file)
        }
      })
      this.$emit("updateDisabled", true)
    },
    handleOpenDeleteDialog(type, item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = { type, item }
    },
    onAddClicked() {
      this.$refs.uploadInput.click()
    },
    handleDelete() {
      // eslint-disable-next-line no-unused-vars
      const { type, item } = this.selectedItem
      this[type + "Picture"] = null
      this.deleteDialogIsOpen = false
      this.$store.commit("app/message", {
        msg: this.$t("messages.information.signature"),
        color: "success"
      })
    },
    onDeleteClicked() {
      this.$emit("input", null)
      this.$emit("updateDisabled", false)
      this.deleteDialogIsOpen = false
    },
    update(file_reader) {
      this.$emit("input", file_reader.result)
      this.isLoading = false
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    }
  }
}
</script>
